<template>
  <div class="list-top">
    <van-dropdown-menu class="dropdown-box" active-color="#4A79F1">
      <van-icon name="arrow-down" class="dropdown-icon" />
      <van-dropdown-item
        :value="dropdownValue"
        :options="dropdownOption"
        @change="dropdownChange"
      />
    </van-dropdown-menu>
    <p class="list-total">共{{ total }}条</p>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem, Icon } from "vant";
export default {
  components: {
    "van-dropdown-menu": DropdownMenu,
    "van-dropdown-item": DropdownItem,
    "van-icon": Icon,
  },
  props: {
    dropdownValue: {
      required: true,
      default: "0",
    },
    dropdownOption: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    dropdownChange(value) {
      this.$emit("getDropdownValue", value);
    },
  },
};
</script>

<style scoped lang="scss">
.list-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  height: 45px;
  background-color: #fff;
  .dropdown-box {
    position: relative;
    height: 30px;
    .dropdown-icon {
      position: absolute;
      top: 50%;
      right: 13px;
      margin-top: -6px;
      z-index: 99;
      font-size: 12px;
    }
    &::v-deep .van-dropdown-menu__bar {
      width: 100%;
      height: 100%;
      background-color: #f7f8fa;
      border-radius: 15px;
    }
    &::v-deep .van-dropdown-menu__title {
      max-width: 150px;
      padding: 0 30px 0 12px;

      &::after {
        content: none;
      }
    }
    &::v-deep .van-dropdown-item {
      .van-cell {
        &::after {
          border-bottom: none;
        }
      }
    }
  }
  .list-total {
    font-size: 13px;
    color: #999999;
    line-height: 19px;
  }
}
</style>